<template>
  <div class="w-100">
    <no-site v-if="noSiteId"/>
    <template v-else>
      <page-loader v-if="fetchingSites"/>
      <template v-else>
        <no-site v-if="sites.length < 1"/>
        <page-loader v-else-if="loading"/>
        <feature-disabled v-else-if="!generalRegistrationEnabled"/>
        <template v-else-if="subscriptionFeatureAllowed">
          <slot></slot>
        </template>
        <no-subscription v-else/>
      </template>
    </template>
  </div>
</template>

<script>
import { SiteCacheMixin } from '@/mixins/Booking/SiteCacheMixin'
import { SubscriptionCacheMixin } from '@/mixins/Booking/SubscriptionCacheMixin'
import { GeneralRegistrationSettingsCacheMixin } from '@/mixins/GeneralRegistration/GeneralRegistrationSettingsCacheMixin'
import { BrandingSettingMixin } from '@/mixins/Booking/BrandingSettingMixin'
import PageLoader from '../Loading/PageLoader.vue'
import NoSiteFound from './NoSiteFound.vue'
import FeatureDisabled from './FeatureDisabled.vue'
import NoSubscription from './NoSubscription.vue'

export default {
  name: 'SettingsChecker',
  mixins: [SiteCacheMixin, SubscriptionCacheMixin, GeneralRegistrationSettingsCacheMixin, BrandingSettingMixin],
  computed: {
    featureKey () {
      return 'onlineRegistration'
    },
    noSiteId () {
      return !this.siteId
    },
    generalRegistrationEnabled () {
      return !!this.attemptedGeneralRegistrationSettings && !!this.enabled && !this.fetchingGeneralRegistrationSettings
    },
    loading () {
      return !!this.fetchingClientRegistrationSettings || !!this.loadingSetting || !!this.fetchingSubscription
    }
  },
  components: {
    'page-loader': PageLoader,
    'no-site': NoSiteFound,
    'feature-disabled': FeatureDisabled,
    'no-subscription': NoSubscription
  }
}
</script>
